<template>
  <side-panel-inner headerTitle="File Preview" v-if="documentReady && uploadedFile.id">
    <template slot="actions">
      <base-button danger iconBefore="cross" @click="onClickDelete">Delete</base-button>
      <base-button
        :primary="true"
        iconBefore="download"
        v-if="uploadedFile"
        @click="onClickDownload"
      >Download</base-button>
    </template>

    <div v-if="fileReady">
      <pdf-preview v-if="uploadedFile.mime_type == 'application/pdf'" :fileId="uploadedFile.id"></pdf-preview>
      <img :src="fileSrc" v-else-if="uploadedFile.mime_type.includes('image')">
      <div v-else>
        <h3>There was a problem</h3>
        <p>
          The file could not be previewed. Please
          <a
            href="#"
            @click.prevent="onClickDownload"
          >click here to download it</a>.
        </p>
      </div>
    </div>
    <loading v-else></loading>
  </side-panel-inner>

  <side-panel-inner v-else>
    <loading></loading>
  </side-panel-inner>
</template>

<script>
import { mapState } from "vuex";
import PdfPreview from "@/components/PdfPreview";
import Dropdown from "@/components/Dropdown";
import DropdownAction from "@/components/DropdownAction";
import Callout from "@/components/Containers/BaseCallout";
import DownloadWarning from "@/components/DownloadWarning";
import filesApi from "@/api/files";

export default {
  name: "file-preview",

  data() {
    return {
      documentReady: false,
      fileReady: false,
      downloadPercent: 0,
      hideWarning: false,
      fileSrc: null,
      isIE: false,
      fileLink: null
    };
  },

  beforeMount() {
    const vm = this;
    const fileId = this.$route.params.id;

    // so that the background isn't empty...
    if (!this.$store.state.files.files) {
      this.$store.dispatch("files/list");
    }

    this.$store.dispatch("files/read", fileId).then(() => {
      vm.documentReady = true;
      vm.fileReady = true;
    });
  },

  mounted() {
    this.getFile();
  },

  computed: {
    ...mapState("files", ["uploadedFile"]),

    hasPermissionToUpdate() {
      if (!this.$store.state.auth.currentUser.privileges) {
        this.$store.dispatch("auth/listCurrentUser").then(resp => {
          return this.$store.state.auth.currentUser.privileges[
            `add_${this.$route.params.docType}`
          ];
        });
      } else {
        return this.$store.state.auth.currentUser.privileges[
          `add_${this.$route.params.docType}`
        ];
      }
    }
  },

  methods: {
    getFile() {
      const vm = this;
      filesApi.read(this.$route.params.id).then(file => {
        this.fileLink = file.link;

        filesApi.readLink(file.link).then(response => {
          this.setFileData(response.data);
        });
      });
    },
    setFileData(blob) {
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        this.isIE = true;
        return;
      }

      const vm = this;
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function() {
        const base64data = reader.result;
        vm.fileSrc = base64data;
      };
    },
    onClickDownload() {
      this.$store.dispatch("files/read", this.$route.params.id).then(resp => {
        this.$store.dispatch("files/download", resp);
      });
    },
    onClickDelete() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        // TODO: This does the right thing, but do we need to create its own
        // method in the store so we can alter the confirmation etc.?
        confirm: () => {
          this.$store
            .dispatch("files/delete", this.$route.params.id)
            .then(resp => {
              vm.$store.dispatch("notifications/create", {
                body: "The file has been deleted",
                type: "success"
              });
              this.$store.dispatch('CLOSE_PANEL','AdminFilesIndexPage');
            })
            .catch(err => {
              vm.$store.dispatch("notifications/create", {
                body: `There was a problem - ${err}`,
                type: "danger"
              });
            });
        }
      });
    }
  },

  components: {
    PdfPreview,
    Dropdown,
    DropdownAction,
    Callout,
    DownloadWarning
  }
};
</script>
